import {
  ADMIN_LOADED, ADMIN_AUTH_ERROR, ADMIN_LOGIN_SUCCESS,
  ADMIN_LOGIN_FAIL, ADMIN_LOGOUT
} from '../actions/types';

const initialState = {
  token: localStorage.getItem('adminToken'),
  isAuthenticated: false,
  admin: null,
  loading: true,
  error: null
};

export default function (state = initialState, action) {
  const { type, payload } = action;

  switch (type) {
    case ADMIN_LOADED:
      return {
        ...state,
        isAuthenticated: true,
        loading: false,
        admin: payload,
        error: null
      };
    case ADMIN_LOGIN_SUCCESS:
      localStorage.setItem('adminToken', payload.token);
      return {
        ...state,
        token: payload.token,
        isAuthenticated: true,
        loading: false,
        error: null
      };
    case ADMIN_AUTH_ERROR:
    case ADMIN_LOGOUT:
      localStorage.removeItem('adminToken');
      return {
        token: null,
        isAuthenticated: false,
        admin: null,
        loading: false,
        error: null
      };
    case ADMIN_LOGIN_FAIL:
      return {
        ...state,
        error: payload
      };
    default:
      return state;
  }
}
